import React, { useState, useEffect } from 'react';
import { Typography, Box, Card, CardContent } from '@mui/material';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const target = new Date(targetDate).getTime();
      const difference = target - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  if (timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h5" align="center">
            🎉 Event is happening now!
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom align="center">
          Time Until Event
        </Typography>
        <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap">
          <Box textAlign="center">
            <Typography variant="h4" color="primary">
              {timeLeft.days}
            </Typography>
            <Typography variant="body2">Days</Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="h4" color="primary">
              {timeLeft.hours}
            </Typography>
            <Typography variant="body2">Hours</Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="h4" color="primary">
              {timeLeft.minutes}
            </Typography>
            <Typography variant="body2">Minutes</Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="h4" color="primary">
              {timeLeft.seconds}
            </Typography>
            <Typography variant="body2">Seconds</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CountdownTimer;
